export const Disruptions = {
  min: 0,
  max: 60,
  default: 8,
};

export const Developers = {
  min: 0,
  max: 500,
  default: 150,
};

export const ITOpsEmployees = {
  min: 0,
  max: 500,
  default: 50,
};

export const AverageTime = {
  default: 'Hours',
  LessThan30Mins: 'Less than 30 mins',
  Mins30To90: '30-90 mins',
  Days: 'Days+',
};

export const YEARLY = 12;

export const DisruptionBucketHours = {
  speedGain: 1.5,
  reduction: 3,
};

export const DisruptionBucketDays = {
  speedGain: 12,
  reduction: 16,
};

export const DisruptionBucket30To90Mins = {
  speedGain: 1 / 2,
  reduction: 1,
};

export const DisruptionBucketLessThan30Mins = {
  speedGain: 1 / 6,
  reduction: 1 / 3,
};

export const OpenSourceTechnologies = {
  prometheus: 'Prometheus ',
  openTracing: 'OpenTracing ',
  openTelemetry: 'OpenTelemetry ',
  jaeger: 'Jaeger ',
  zipkin: 'Zipkin ',
  openCensus: 'OpenCensus ',
};

export interface AvgTimePerDistruptions {
  speedGain: number;
  reduction: number;
}

export const isEmptyString = (data: string): boolean =>
  typeof data === 'string' && data.trim().length == 0;

export const SKELETON_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAEElEQVR42mN8+p+BgRFEAAAWrwPLzYNPyAAAAABJRU5ErkJggg==';

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30InstanaROI = '30AO8';
export const emailCOSJson = 'instanaBVA.json';
